import React, { useState } from "react";
import { Alert, Box, Button, Snackbar } from "@common-ui/ui";
import { MainDialog } from "./MainDialog";
import PropTypes from "prop-types";
import _ from "lodash";
import {
  // getProcedure,
  getServiceOptions,
  getServiceTypesForOrg,
  // getWorkItem,
} from "../../services";
import { Add } from "@mui/icons-material";
// import { getCustomerAssets } from "../../services";

const TransferList = ({
  workEvent,
  workItems,
  setWorkItems,
  assets,
  setAssets,
  createWorkItems,
  serverWorkItems,
  setServerWorkItems,
  getWorkItems,
  orgID,
  removeWorkItems,
  allAsset,
  customer,
  places,
  newPlaceParent,
  initTransferList,
  appRole,
}) => {
  let doesUserHavePermission = appRole === "ADMIN" || appRole === "SUPERVISOR";
  const [mainDialog, setMainDialog] = useState({ isOpen: false });
  const [updatedLeft, setUpdatedLeft] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState([]);
  const handleClose = async () => {
    setMainDialog({ ...mainDialog, isOpen: false });
  };
  const handleOpen = () => {
    setMainDialog({ ...mainDialog, isOpen: true });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const indexLookUp = _.keyBy(serverWorkItems, (object) => {
        return object.asset;
      });
      const workItemsToBeRemoved = _.filter(updatedLeft, (item) => {
        return item["workItemID"] !== undefined;
      });
      const newWorkItem = _.filter(workItems, (asset) => {
        return indexLookUp[asset?.system_id] === undefined;
      });
      let serviceTypes, serviceOptions;
      if (orgID) {
        serviceTypes = await getServiceTypesForOrg(orgID);
      }
      if (serviceTypes) {
        serviceOptions = await getServiceOptions(
          serviceTypes[0]?.system_id,
          orgID
        );
      }
      const attributes = Array.from(newWorkItem).map((item, i) => {
        return {
          display_order: serverWorkItems.length + i,
          asset: item?.system_id,
          service_type: serviceTypes[0]?.system_id,
          service_option: serviceOptions[0]?.system_id,
          performing_org: orgID,
          performing_user: null,
          status: "DRAFT",
        };
      });
      if (workItems?.length) {
        try {
          await createWorkItems(attributes, workEvent?.id, orgID);
        } catch (error) {
          setToast([
            ...toast,
            {
              message:
                error?.response?.status === 405
                  ? "Procedure not found ."
                  : error.message,
              open: true,
              severity: "error",
            },
          ]);
          setIsLoading(false);
          handleClose();
          return;
        }
      }
      if (workItemsToBeRemoved?.length) {
        for (const newItem of workItemsToBeRemoved) {
          try {
            // const deleted =
            await removeWorkItems(orgID, newItem["workItemID"]);
            // console.log("deleted", deleted);
          } catch (error) {
            console.log(error);
          }
        }
      }
      if (!workItems.length) {
        for (const newItem of serverWorkItems) {
          try {
            // console.log("deleted", newItem);
            // const deleted =
            await removeWorkItems(orgID, newItem["id"]);
            // console.log("deleted", deleted);
          } catch (error) {
            console.log(error);
          }
        }
      }
      initTransferList(customer, newPlaceParent, workEvent);
      // let newAssets = [];

      // if (customer && workEvent) {
      //   console.log("Reset");
      //   newAssets = await getCustomerAssets(orgID, customer.id);
      // }
      // console.log("Reset asset", newAssets);
      // if (newPlaceParent) {
      //   // newAssets = newAssets.filter(
      //   //   (asset) => asset["place"]["system_id"] === newPlaceParent?.system_id
      //   // );
      //   // console.log("newAssets", newAssets);
      //   newAssets = newAssets.filter((newAsset) => {
      //     if (newAsset["place"] && newAsset["place"]["system_id"]) {
      //       // console.log(
      //       //   "newAsset",
      //       //   newAsset,
      //       //   "place",
      //       //   newPlaceParent?.system_id
      //       // );
      //       if (newPlaceParent.system_id) {
      //         return (
      //           newAsset["place"]["system_id"] === newPlaceParent?.system_id
      //         );
      //       } else {
      //         return newAsset["place"]["system_id"] === newPlaceParent?.id;
      //       }
      //     }
      //     return false;
      //   });
      // }
      // // console.log("newAssets", newAssets);
      // const newServerWorkItems = await getWorkItems(workEvent?.id, orgID);
      // setServerWorkItems(newServerWorkItems);
      // const indexLookUp2 = _.keyBy(newServerWorkItems, (object) => {
      //   return object.asset;
      // });
      // const filterNewAssets = _.filter(newAssets, (asset) => {
      //   return indexLookUp2[asset.system_id] === undefined;
      // });
      // // console.log("filterNewAssets", filterNewAssets);
      // setAssets(filterNewAssets);
      // // console.log("filterWorkItems", indexLookUp2);
      // let filterWorkItems = _.map(newAssets, (asset) => {
      //   if (indexLookUp2[asset.system_id] !== undefined) {
      //     return {
      //       ...asset,
      //       workItemID: indexLookUp2[asset?.system_id]["system_id"],
      //     };
      //   } else {
      //     return asset;
      //   }
      // });
      // // console.log("filterWorkItems", filterWorkItems);

      // filterWorkItems = _.filter(filterWorkItems, (asset) => {
      //   return indexLookUp2[asset.system_id] !== undefined;
      // });

      // // console.log("filterNewAssets", filterNewAssets);

      // setWorkItems(filterWorkItems);

      setToast([
        ...toast,
        {
          message: "Work Items has been saved.",
          open: true,
          severity: "success",
        },
      ]);
      setIsLoading(false);
      handleClose();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      handleClose();
    }
  };

  // console.log("workItems", workItems);

  return (
    <Box>
      {doesUserHavePermission ? (
        <Button
          variant="outlined"
          startIcon={<Add />}
          disabled={
            customer ? (workEvent?.status !== "DRAFT" ? true : false) : true
          }
          onClick={() => handleOpen()}
        >
          Add Assets
        </Button>
      ) : (
        ""
      )}
      <MainDialog
        workEventID={workEvent?.id}
        open={mainDialog.isOpen}
        handleClose={handleClose}
        workItems={workItems}
        setWorkItems={setWorkItems}
        data={assets}
        setAssets={setAssets}
        handleSubmit={handleSubmit}
        orgID={orgID}
        removeWorkItems={removeWorkItems}
        updatedLeft={updatedLeft}
        setUpdatedLeft={setUpdatedLeft}
        isLoading={isLoading}
        serverWorkItems={serverWorkItems}
        allAsset={allAsset}
      />
      {toast.map((item, id) => {
        return (
          <Snackbar
            key={id}
            open={item.open}
            autoHideDuration={6000}
            onClose={() => {
              setToast(toast.filter((v, i) => i !== id));
            }}
          >
            <Alert
              onClose={() => {
                setToast(toast.filter((v, i) => i !== id));
              }}
              severity={item.severity}
              sx={{ width: "100%" }}
              variant="filled"
            >
              {item.message}
            </Alert>
          </Snackbar>
        );
      })}
    </Box>
  );
};

TransferList.propTypes = {
  workEvent: PropTypes.any,
  workItems: PropTypes.array,
  setWorkItems: PropTypes.any,
  setAssets: PropTypes.any,
  assets: PropTypes.array,
  createWorkItems: PropTypes.any,
  serverWorkItems: PropTypes.array,
  setServerWorkItems: PropTypes.any,
  getWorkItems: PropTypes.any,
  orgID: PropTypes.any,
  removeWorkItems: PropTypes.any,
  allAsset: PropTypes.array,
  customer: PropTypes.any,
  places: PropTypes.array,
  newPlaceParent: PropTypes.any,
  initTransferList: PropTypes.any,
};

TransferList.defaultProps = {
  workItems: [],
  assets: [],
};

export { TransferList };
